import { gql } from "@apollo/client";

export const AddRfq = gql`
  mutation AddRfq(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $user_details: SubscribedUser!
    $input: CreateRfq!
  ) {
    AddRfq(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateRfq = gql`
  mutation UpdateRfq(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $rfqId: ID!
    $user_details: SubscribedUser!
    $input: UpdateRfq!
  ) {
    UpdateRfq(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      rfqId: $rfqId
      user_details: $user_details
      input: $input
    )
  }
`;

export const AddRfqTrnSupply = gql`
  mutation AddRfqTrnSupply($ldgrID: ID!, $input: [CreateRfqTrnSupply!]!) {
    AddRfqTrnSupply(ldgrID: $ldgrID, input: $input)
  }
`;

export const DeleteRfq = gql`
  mutation DeleteRfq(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $rfqId: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteRfq(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      rfqId: $rfqId
      user_details: $user_details
    )
  }
`;

export const SendEmailToSuppliers = gql`
  mutation SendEmailToSuppliers(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $rfqId: ID!
    $user_details: SubscribedUser!
  ) {
    SendEmailToSuppliers(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      rfqId: $rfqId
      user_details: $user_details
    )
  }
`;

export const UpdateRfqTrnSupplyQuote = gql`
  mutation UpdateRfqTrnSupplyQuote(
    $uuid: String!
    $input: [UpdateRfqTrnSupply!]!
  ) {
    UpdateRfqTrnSupplyQuote(uuid: $uuid, input: $input)
  }
`;

export const SubmitQuotation = gql`
  mutation SubmitQuotation($uuid: String!) {
    SubmitQuotation(uuid: $uuid)
  }
`;
